module.exports = __webpack_public_path__ + "static/media/para_num.20ad1923.ico";